// Pagination constants for limit options across all admin pages
export const PAGINATION_LIMITS = {
  DEFAULT: 20,
  OPTION_50: 50,
  OPTION_100: 100,
  UNLIMITED: 99999,
} as const;

export const LIMIT_OPTIONS = [
  PAGINATION_LIMITS.DEFAULT,
  PAGINATION_LIMITS.OPTION_50,
  PAGINATION_LIMITS.OPTION_100,
  PAGINATION_LIMITS.UNLIMITED,
] as const;

export const LIMIT_LABELS: Record<number, string> = {
  [PAGINATION_LIMITS.DEFAULT]: "20",
  [PAGINATION_LIMITS.OPTION_50]: "50",
  [PAGINATION_LIMITS.OPTION_100]: "100",
  [PAGINATION_LIMITS.UNLIMITED]: "All",
} as const;

export type LimitOption = (typeof LIMIT_OPTIONS)[number];
